import { getMilesPerYearOptions } from '@/catalog/utils/get-miles-per-year-options';

const milesPerYearName = (miles: number, values: string[] = []) => {
  const options = getMilesPerYearOptions(values); // Get filtered or all options
  return options.find((option) => parseInt(option.value) === miles)?.name || '';
};

interface MileageDescriptionProps {
  planMileage: number;
  values?: string[]; // Optional filtering values
}

export default function MileageDescription({
  planMileage,
  values = [], // Default to all options
}: MileageDescriptionProps) {
  return (
    <div className="flex flex-col gap-[8px] text-left">
      <p className="body">{milesPerYearName(planMileage, values)}</p>
    </div>
  );
}
